<i18n>
{
	"en": {
		"edipartName": "EDIPART name",
		"sender": "Message sender",
		"recipient": "Message recipient",
		"messageType": "Message type",
		"messageFormat": "Message format",
		"endpoint": "Endpoint server",
		"path": "Endpoint path",
		"transportMethod": "Transportation method",
		"title": "Edipart details -",
		"encoding": "Encoding",
		"externalCustomerNo": "External customernumber"
	},
	"no": {
		"edipartName": "EDIPART navn",
		"sender": "Meldings avsender",
		"recipient": "Meldings mottaker",
		"messageType": "Meldingstype",
		"messageFormat": "Meldingsformat",
		"endpoint": "Server endepunkt",
		"path": "Sti",
		"transportMethod": "Transportmetode",
		"title": "Edipart detaljer -",
		"encoding": "Koding",
		"externalCustomerNo": "Eksternt kundenummer"
	}
}

</i18n>
<template>

	<t-dialog
		:isShown="isShown"
		:title="`${$t('title')} ${edipart.name}`"
		icon="order"
		iconColor="blue"
		width="600px"
		@close="$emit('close')"
	>
		<TTextInput
			disabled
			:label="$t('edipartName')"
			:value="edipart.name"
		/>
		<div v-if="edipart.outboundSetup">
			<TTextInput
				disabled
				:label="$t('sender')"
				:value="edipart.outboundSetup.sender"
			/>
			<TTextInput
				disabled
				:label="$t('recipient')"
				:value="edipart.outboundSetup.recipient"
			/>
			<TTextInput
				disabled
				:label="$t('messageType')"
				:value="edipart.outboundSetup.messageTypeDescription"
			/>
			<TTextInput
				disabled
				:label="$t('messageFormat')"
				:value="edipart.outboundSetup.messageFormatDescription"
			/>
			<TTextInput
				disabled
				:label="$t('endpoint')"
				:value="edipart.outboundSetup.endpoint"
			/>
			<TTextInput
				disabled
				:label="$t('path')"
				:value="edipart.outboundSetup.path"
			/>
			<TTextInput
				disabled
				:label="$t('transportMethod')"
				:value="edipart.outboundSetup.transportMethod"
			/>
			<TTextInput
				disabled
				:label="$t('encoding')"
				:value="edipart.outboundSetup.encoding"
			/>
			<TTextInput
				disabled
				:label="$t('externalCustomerNo')"
				:value="vendor.externalCustomerId"
			/>
		</div>
	</t-dialog>
</template>

<script>

import getEdipartDetailsRequest from './getEdipartDetailsRequest';

export default {

	props: {
		isShown: Boolean,
		vendor: Object,
		edipart: Object
	},

	async created() {
		this.edipart = await getEdipartDetailsRequest(this.vendor.edipartId);
	}
};
</script>

<style>

</style>